<script>
import UploadZone from '@/components/UploadZone.vue'
import BotoesNavegacao from '@/components/BotoesNavegacao.vue'

export default {
  components: { UploadZone, BotoesNavegacao },

  props: {
    form:    { type: Object, required: true },
    docFront: { type: File, default: null },
    docBack:  { type: File, default: null },
  },

  computed: {
    versoObrigatorio() { return this.form.tipo_documento === 'rg' },
    legendaVerso() {
      return this.versoObrigatorio
        ? 'Verso do documento (obrigatório)'
        : 'Verso do documento (opcional)'
    },
  },

  methods: {
    setTipo(tipo) {
      if (this.form.tipo_documento !== tipo) {
        this.form.tipo_documento = tipo
      }
    },
    onFront(file) { this.$emit('doc-front-changed', file) },
    onFrontRemover() { this.$emit('doc-front-changed', null) },
    onBack(file)  { this.$emit('doc-back-changed', file) },
    onBackRemover() { this.$emit('doc-back-changed', null) },

    avancar() {
      if (!this.docFront) {
        this.$toast.error('Envie a frente do documento.')
        return
      }
      if (this.versoObrigatorio && !this.docBack) {
        this.$toast.error('Para RG, envie também o verso.')
        return
      }
      this.$emit('avancar')
    },
  },
}
</script>

<template>
  <div>
    <div class="form-row">
      <label class="field-label">Tipo de documento</label>
      <div class="toggle-group">
        <button
          type="button"
          class="toggle-group__btn"
          :class="{ 'toggle-group__btn--active': form.tipo_documento === 'cnh' }"
          @click="setTipo('cnh')"
        >CNH</button>
        <button
          type="button"
          class="toggle-group__btn"
          :class="{ 'toggle-group__btn--active': form.tipo_documento === 'rg' }"
          @click="setTipo('rg')"
        >RG</button>
      </div>
    </div>

    <div class="form-row">
      <label class="field-label">Frente do documento</label>
      <UploadZone
        label="Foto ou PDF da frente do documento"
        accept="image/*,.pdf,application/pdf"
        :value="docFront ? docFront.name : ''"
        :max-mb="50"
        hint="Arquivo de até 50MB"
        @change="onFront"
        @remover="onFrontRemover"
      />
    </div>

    <div class="form-row">
      <label class="field-label">{{ legendaVerso }}</label>
      <UploadZone
        label="Foto ou PDF do verso do documento"
        accept="image/*,.pdf,application/pdf"
        :value="docBack ? docBack.name : ''"
        :max-mb="50"
        :hint="versoObrigatorio ? 'Obrigatório para RG.' : 'Anexe se a CNH tiver dados no verso.'"
        @change="onBack"
        @remover="onBackRemover"
      />
    </div>

    <BotoesNavegacao @voltar="$emit('voltar')" @avancar="avancar" />
  </div>
</template>
